// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagedetails__container {

}
.pagedetails__row--one {
    position: sticky;
    top: 0px;
    z-index: 10;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.pagedetails__row--two {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem
}
.pagedetails__row--two .pagedetails__col--one {
    position: sticky;
    top: 5rem;
    height: 78vh;
    width: 100%;
    overflow-y: scroll;
    border-radius: 0.375rem
}
.pagedetails__row--two .pagedetails__col--one .pagedetails__col--one-wrapper {
    height: fit-content;
    width: 100%;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
/* .pagedetails__row--two .pagedetails__col--one::-webkit-scrollbar {
    display: none;
}
.pagedetails__row--two .pagedetails__col--one {
    -ms-overflow-style: none;  
    scrollbar-width: none;  
} */
.pagedetails__row--two .pagedetails__col--two {
    grid-column: span 2 / span 2;
    height: fit-content;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.pagedetails__row--two .pagedetails__col--two .input__field {
    display: flex;
    height: 8rem;
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 0.375rem;
    border-width: 2px;
    border-style: dotted
}
.pagedetails__row--two .pagedetails__col--three {
    position: sticky;
    top: 5rem;
    max-height: 78vh;
    min-height: 20vh;
    overflow-y: scroll;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
/* .pagedetails__row--two .pagedetails__col--three::-webkit-scrollbar {
    display: none;
}
.pagedetails__row--two .pagedetails__col--three {
    -ms-overflow-style: none;  
    scrollbar-width: none; 
} */
.indivisual_widget {}
.indivisual_widget .name {
    border-bottom-width: 1px;
    padding-bottom: 0.75rem;
    text-align: center;
    text-transform: capitalize;
    letter-spacing: 0.05em
}
.pagedetails__col--three {

}
.pagedetails__col--three .indivisual_widget {

}
.pagedetails__col--three .indivisual_widget form {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1rem
}
.delete_icon {
    position: absolute;
    top: -0.75rem;
    right: -0.75rem;
    z-index: 10;
    cursor: pointer;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.25rem;
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.choose__images--btn {
    margin-top: 0.5rem;
    display: flex;
    height: 3rem;
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 0.375rem;
    border-width: 1px;
    border-style: dotted;
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
    padding: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-transform: capitalize;
    letter-spacing: 0.05em;
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}`, "",{"version":3,"sources":["webpack://./src/pages/PageDetails/pagedetails.css"],"names":[],"mappings":"AAAA;;AAEA;AAEI;IAAA,gBAA+I;IAA/I,QAA+I;IAA/I,WAA+I;IAA/I,mBAA+I;IAA/I,aAA+I;IAA/I,mBAA+I;IAA/I,8BAA+I;IAA/I,uBAA+I;IAA/I,kBAA+I;IAA/I,4DAA+I;IAA/I,aAA+I;IAA/I,kBAA+I;IAA/I,oBAA+I;IAA/I,gBAA+I;IAA/I,yBAA+I;IAA/I,uBAA+I;IAA/I,+EAA+I;IAA/I,mGAA+I;IAA/I;AAA+I;AAG/I;IAAA,aAA6B;IAA7B,gDAA6B;IAA7B;AAA6B;AAG7B;IAAA,gBAAiE;IAAjE,SAAiE;IAAjE,YAAiE;IAAjE,WAAiE;IAAjE,kBAAiE;IAAjE;AAAiE;AAGjE;IAAA,mBAAqD;IAArD,WAAqD;IAArD,uBAAqD;IAArD,kBAAqD;IAArD,4DAAqD;IAArD,aAAqD;IAArD,+EAAqD;IAArD,mGAAqD;IAArD;AAAqD;AAEzD;;;;;;GAMG;AAEC;IAAA,4BAAyD;IAAzD,mBAAyD;IAAzD,uBAAyD;IAAzD,kBAAyD;IAAzD,4DAAyD;IAAzD,aAAyD;IAAzD,+EAAyD;IAAzD,mGAAyD;IAAzD;AAAyD;AAGzD;IAAA,aAAoG;IAApG,YAAoG;IAApG,WAAoG;IAApG,eAAoG;IAApG,mBAAoG;IAApG,uBAAoG;IAApG,uBAAoG;IAApG,iBAAoG;IAApG;AAAoG;AAGpG;IAAA,gBAAkG;IAAlG,SAAkG;IAAlG,gBAAkG;IAAlG,gBAAkG;IAAlG,kBAAkG;IAAlG,uBAAkG;IAAlG,kBAAkG;IAAlG,4DAAkG;IAAlG,aAAkG;IAAlG,+EAAkG;IAAlG,mGAAkG;IAAlG;AAAkG;AAEtG;;;;;;GAMG;AACH,oBAAoB;AAEhB;IAAA,wBAA0D;IAA1D,uBAA0D;IAA1D,kBAA0D;IAA1D,0BAA0D;IAA1D;AAA0D;AAE9D;;AAEA;AACA;;AAEA;AAEI;IAAA,aAA6B;IAA7B,gDAA6B;IAA7B;AAA6B;AAG7B;IAAA,kBAAoG;IAApG,aAAoG;IAApG,eAAoG;IAApG,WAAoG;IAApG,eAAoG;IAApG,qBAAoG;IAApG,kBAAoG;IAApG,4DAAoG;IAApG,gBAAoG;IAApG,oBAAoG;IAApG,iDAAoG;IAApG,+EAAoG;IAApG,mGAAoG;IAApG;AAAoG;AAGpG;IAAA,kBAAiL;IAAjL,aAAiL;IAAjL,YAAiL;IAAjL,WAAiL;IAAjL,eAAiL;IAAjL,mBAAiL;IAAjL,uBAAiL;IAAjL,uBAAiL;IAAjL,iBAAiL;IAAjL,oBAAiL;IAAjL,kBAAiL;IAAjL,4DAAiL;IAAjL,eAAiL;IAAjL,mBAAiL;IAAjL,oBAAiL;IAAjL,0BAAiL;IAAjL,sBAAiL;IAAjL,oBAAiL;IAAjL,gDAAiL;IAAjL,6EAAiL;IAAjL,iGAAiL;IAAjL;AAAiL","sourcesContent":[".pagedetails__container {\n\n}\n.pagedetails__row--one {\n    @apply text-xl font-semibold tracking-wide uppercase bg-white shadow-lg p-4 rounded-md mb-4 flex items-center justify-between sticky top-0 z-10;\n}\n.pagedetails__row--two {\n    @apply grid grid-cols-4 gap-4;\n}\n.pagedetails__row--two .pagedetails__col--one {\n    @apply w-full h-[78vh] overflow-y-scroll sticky rounded-md top-20;\n}\n.pagedetails__row--two .pagedetails__col--one .pagedetails__col--one-wrapper{\n    @apply bg-white rounded-md p-4 h-fit shadow-lg w-full;\n}\n/* .pagedetails__row--two .pagedetails__col--one::-webkit-scrollbar {\n    display: none;\n}\n.pagedetails__row--two .pagedetails__col--one {\n    -ms-overflow-style: none;  \n    scrollbar-width: none;  \n} */\n.pagedetails__row--two .pagedetails__col--two {\n    @apply col-span-2 bg-white rounded-md shadow-lg p-4 h-fit;\n}\n.pagedetails__row--two .pagedetails__col--two .input__field {\n    @apply w-full h-32 border-2 border-dotted rounded-md flex items-center justify-center cursor-pointer;\n}\n.pagedetails__row--two .pagedetails__col--three {\n    @apply bg-white rounded-md shadow-lg p-4 max-h-[78vh] min-h-[20vh] overflow-y-scroll sticky top-20;\n}\n/* .pagedetails__row--two .pagedetails__col--three::-webkit-scrollbar {\n    display: none;\n}\n.pagedetails__row--two .pagedetails__col--three {\n    -ms-overflow-style: none;  \n    scrollbar-width: none; \n} */\n.indivisual_widget {}\n.indivisual_widget .name {\n    @apply text-center capitalize tracking-wider border-b pb-3;\n}\n.pagedetails__col--three {\n\n}\n.pagedetails__col--three .indivisual_widget {\n\n}\n.pagedetails__col--three .indivisual_widget form {\n    @apply grid grid-cols-1 gap-4;\n}\n.delete_icon {\n    @apply bg-white text-red-500 absolute -top-3 -right-3 rounded-full p-1 z-10 shadow-lg cursor-pointer;\n}\n.choose__images--btn {\n    @apply border border-dotted w-full h-12 rounded-md shadow-md bg-gray-200 p-2 flex items-center justify-center capitalize tracking-wider text-sm text-gray-600 cursor-pointer mt-2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
